type Translate = (key: string, params?: Record<string, unknown>) => string

type CommissionUser = { id: string | number; full_name: string }
type CommissionNoteRef = { id: string | number; reference: string }

export type CommissionWarning = {
  type: 'item_moved' | 'item_kept'
  reason:
    | 'note_closed'
    | 'new_responsible_not_eligible'
    | 'no_responsible'
    | null
  from: CommissionUser
  to: CommissionUser | null
  commission_note: CommissionNoteRef
  previous_commission_note: CommissionNoteRef | null
}

/**
 * What the API tells when converting a purchase order into an invoice changes
 * (or would have changed) who earns the commission of the sale.
 */
export function commissionWarningText(
  t: Translate,
  warning: CommissionWarning
): { title: string; message: string } {
  const params = {
    from: warning.from.full_name,
    to: warning.to?.full_name ?? '',
    note: warning.commission_note.reference,
    previous_note: warning.previous_commission_note?.reference ?? ''
  }

  if (warning.type === 'item_moved') {
    return {
      title: t('global.commission_item_moved_title'),
      message: t('global.commission_item_moved_message', params)
    }
  }

  // One complete sentence per reason: nothing is glued together, so each language keeps its own word order
  return {
    title: t('global.commission_item_kept_title'),
    message: warning.reason
      ? t(`global.commission_item_kept_${warning.reason}`, params)
      : ''
  }
}
